import { render, staticRenderFns } from "./SchemaView.vue?vue&type=template&id=67accffb&scoped=true&"
import script from "./SchemaView.vue?vue&type=script&lang=ts&"
export * from "./SchemaView.vue?vue&type=script&lang=ts&"
import style0 from "./SchemaView.vue?vue&type=style&index=0&id=67accffb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67accffb",
  null
  
)

export default component.exports